import { render, staticRenderFns } from "./ParcMenu.vue?vue&type=template&id=49304b92&"
import script from "./ParcMenu.vue?vue&type=script&lang=js&"
export * from "./ParcMenu.vue?vue&type=script&lang=js&"
import style0 from "./ParcMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports